// extracted by mini-css-extract-plugin
export default {"redirectBankWarn":"RW82MKveEsYdoVukfdTi","redirectBankBt":"pOKm1MxuUpPGKFpFgw2f","placeHolderShimmer":"U3vv6s2MqmTdFBniVxL3"};